import { defineStore } from "pinia";
import { NotificationModel } from "../utils/notificationModel";
interface NotificationState {
  requestId: string | null;
  showNotificationPanel: boolean;
  isLoadedAlready: boolean | false;
  dropNotificationList: NotificationModel[];
}

export const useNotificationStore = defineStore("notificatioxxnStore", {
  state: (): NotificationState => ({
    requestId: null as string | null,
    showNotificationPanel: false,
    dropNotificationList: [],
    isLoadedAlready: false,
  }),

  actions: {
    setRequest(requestId: string): void {
      this.requestId = requestId;
    },
    setPanelView(value: boolean): void {
      this.showNotificationPanel = value;
    },

    togglePanelView(): void {
      this.showNotificationPanel = !this.showNotificationPanel;
    },
  },
});
